import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { AuthScreen } from "./AuthScreen";

export function AuthRejection({
  reason,
  onBack,
}: {
  reason: "account-suspended" | "signups-closed";
  onBack: () => void;
}) {
  const { t } = useTranslation();
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    heading.current?.focus();
  }, [reason]);
  const key = reason === "account-suspended" ? "auth.suspended" : "auth.signupsClosed";
  return (
    <AuthScreen>
      <h1 ref={heading} tabIndex={-1} className="font-heading text-2xl font-bold">
        {t(`${key}.title`)}
      </h1>
      <p className="mt-2 mb-6 leading-normal text-muted-foreground">{t(`${key}.description`)}</p>
      <Button className="w-full" onClick={onBack}>
        {t("auth.backToSignIn")}
      </Button>
    </AuthScreen>
  );
}
